import React, {FC} from 'react';
import {ITag} from '@redux/types';
import {useSelectTag} from '@common/hooks/useSelectTag';


const ProjectPageTags: FC<{ tags?: ITag[] }> = ({tags}) => {
  const {selectedTagSlug, setSelectedTagSlug} = useSelectTag('projects');

  return (!!tags?.length && (
    <ul className="portfolio__filter-list" id="projects-page-filter">
      {tags.map((tag) => {
        const linkClasses = `portfolio__filter-link ${selectedTagSlug !== tag?.slug ? '' : 'is-active'}`;

        return (
          <li key={tag.slug} className="portfolio__filter-item">
            <a
              className={linkClasses}
              onClick={(e) => setSelectedTagSlug(tag.slug, e)}
              href={`#${tag?.slug}`}
            >
              <span className="portfolio__filter-text">{tag?.name}</span>
            </a>
          </li>
        )
      })}
    </ul>
  ))
}

export default ProjectPageTags
